export enum PopoverTriggerType {
  click = 'click',
  none = 'none'
}
